import React from "react";
import { collections } from "../data/collections";
import { product } from "../data/product";
import { CtaButton } from "./ui/CtaButton";
import { ImageSlot } from "./ui/ImageSlot";
export function Collections() {
  return <section className="bg-cream px-4 pb-14 sm:px-6 sm:pb-20" aria-label="Collezioni di ricette" data-id="element-59" data-mp="2aziaj8ox3twy">
      <div className="mx-auto max-w-6xl space-y-14 lg:space-y-20" data-id="element-60" data-mp="2frtk739gmu2p">
        {collections.map((c, i) => <article key={c.title} className="grid gap-7 lg:grid-cols-2 lg:items-center lg:gap-14" data-id="element-61" data-mp="2kpla5rqjo649" data-mpi={i}>
            <div className={i % 2 === 1 ? "lg:order-2" : ""} data-id="element-62" data-mp="2pnmush3mcdhu">
              <ImageSlot src={c.image} alt={`Cosmetici fatti in casa: ${c.title.toLowerCase()}`} placeholderLabel={`Foto della collezione ${c.title}`} className="aspect-square w-full rounded-[28px]" data-id="element-63" data-mp="2unr9c1kyuy5f" />
            </div>
            <div data-id="element-64" data-mp="14bbnd21yapfj">
              <h3 className="font-serif text-[28px] font-semibold leading-[1.15] text-wine sm:text-[36px]" data-id="element-65" data-mp="14cwgqocj42bt">
                {c.title}
                <span className="block text-rose" data-id="element-66" data-mp="1bq18s88ychm3">{c.count} ricette</span>
              </h3>
              <p className="mt-4 text-[16px] leading-relaxed text-ink sm:text-[17px]" data-id="element-67" data-mp="16vx2lr7igdm2">
                <strong className="font-semibold text-wine" data-id="element-68" data-mp="11yn1vfeo8fix">{c.lead}</strong>
                {c.description}
              </p>
              <ul className="mt-5" data-id="element-69" data-mp="wx7h7ogeob12">
                {c.items.map(({
              count,
              label,
              icon: Icon
            }) => <li key={label} className="flex items-center gap-3 border-b border-line py-3 last:border-0" data-id="element-70" data-mp="1ukg8y1702gbi">
                    <Icon className="h-[18px] w-[18px] shrink-0 text-rose" strokeWidth={1.5} aria-hidden="true" data-id="element-71" data-mp="1komqy2aihumc" />
                    <span className="text-[15px] leading-snug text-ink" data-id="element-72" data-mp="1fq1odw7seyuq">
                      <strong className="mr-1 font-bold text-wine" data-id="element-73" data-mp="1frwc1iag152i">{count}</strong>
                      {label}
                    </span>
                  </li>)}
              </ul>
            </div>
          </article>)}
        <div className="flex justify-center" data-id="element-74" data-mp="2shd6h40b1ne3">
          <CtaButton data-id="element-75" data-mp="2seh85ekjowp4">Ottieni le {product.recipes} ricette</CtaButton>
        </div>
      </div>
    </section>;
}